<!-- Header-Section -->
<!-- <div class="d-flex h-100 flex-column-" style="flex-flow: column"> -->
<div class="h-100 main-app-start">
  <div *ngIf="loggedUserId > 0">
    <app-dashboard-header></app-dashboard-header>
  </div>

  <div class="container-fluid pt-4 pb-3" [ngClass]="{'overflow-hidden': isToursModule}" style="background-color: rgb(248, 250, 255); flex-grow: 1;margin-top: 59px; max-height: calc(100vh - 59px); overflow-y: scroll;" *ngIf="!hideSidebar">
    <div class="row h-100">
      <div class="col-lg-2 p-1 h-100" *ngIf="!appUserPath.includes('contact')">
        <!-- <app-user-sidebar></app-user-sidebar> -->
        <app-user-sidebar *ngIf="isAppUserBoard"></app-user-sidebar>
        <app-sidebar *ngIf="!isAppUserBoard" class="d-flex h-100"></app-sidebar>
      </div>
      <div id="right_side_block" [ngClass]="{'col-lg-12': appUserPath.includes('contact'), 'col-lg-10  h-100 px-0': !appUserPath.includes('contact')}">
        <div class="p-0 mt-1 h-100">
          
          <router-outlet></router-outlet>

        </div>
      </div>
    </div>
  </div>

  <router-outlet *ngIf="hideSidebar" style="background-color: rgb(248, 250, 255); margin-top: 75px;"></router-outlet>

</div>